import React from 'react';

import PropTypes from 'prop-types';

import {
    Accordion,
    MarkdownContent,
    Typography,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import CarrierImageGrid from './CarrierImageGrid';
import CarrierTitle from './CarrierTitle';

import styles from './CarrierListItem.scss';

function CarrierListItem(props) {
    const {
        namespace,
        carrierData,
        i18nMoney,
        t,
    } = props;
    const {
        carrierCode,
        carrierName,
        images = [],
        metrics,
    } = carrierData;
    const {
        minPriceUsd,
        averagePriceUsd, // todo: place guides only send averagePriceUsd
    } = metrics;

    if (!minPriceUsd && !averagePriceUsd) {
        return null;
    }

    return (
        <li
            className={styles.root}
        >
            <Accordion
                id={carrierCode}
                isOpen={false}
                label={carrierName}
                title={
                    <CarrierTitle
                        carrierCardTitle={t(`${namespace}:${carrierCode}_carrierCardLabel`)}
                        carrierCode={carrierCode}
                        carrierName={carrierName}
                    />
                }
            >
                <div className={styles.description}>
                    <Typography
                        component={MarkdownContent}
                        paragraph
                    >
                        {t(`${namespace}:${carrierCode}_carrierCardText${carrierCode}`, {
                            averageMinimumPrice: i18nMoney(minPriceUsd || averagePriceUsd).format({
                                maximumFractionDigits: 0,
                                minimumFractionDigits: 0,
                            }),
                        })}
                    </Typography>
                </div>
                <div className={styles.imageContainer}>
                    <CarrierImageGrid
                        images={images}
                        namespace={namespace}
                    />
                </div>
            </Accordion>
        </li>
    );
}

CarrierListItem.propTypes = {
    namespace: PropTypes.string.isRequired,
    carrierData: PropTypes.shape({
        carrierCode: PropTypes.string.isRequired,
        carrierName: PropTypes.string.isRequired,
        images: PropTypes.arrayOf(PropTypes.shape({
            slug: PropTypes.string,
            alt: PropTypes.string,
        })),
        metrics: PropTypes.shape({
            minPriceUsd: PropTypes.number,
        }),
    }),
};
CarrierListItem.defaultProps = {
    carrierData: {
        images: [],
        metrics: {
            minPriceUsd: 0,
        },
    },
};

export { CarrierListItem };
export default localize(CarrierListItem);
